import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userApi } from '../api/userApi';

/**
 * PATCH /api/eraf/users/{id}/unlock — 사용자 잠금 해제
 * 성공 시 상세/목록 쿼리 무효화
 */
export function useUnlockUser(id: number) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: () => userApi.unlock(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['user-management', 'detail', id] });
      void qc.invalidateQueries({ queryKey: ['user-management', 'list'] });
    },
  });
}
